import { render } from "./EstadisticasBono.vue?vue&type=template&id=31ad80b0"
import script from "./EstadisticasBono.vue?vue&type=script&lang=js"
export * from "./EstadisticasBono.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__